module.exports = function() {
  return new Worker("/" + "svelte-transpiler.279017bb.worker.js");
};